/**
 * Goal : Parcourir un arbre de noeuds HTML, et tronquer le contenu text de chaque noeud en fonction de la longueur autorisée.
 * @param element noeud DOM à tronquer.
 * @param authorizedLength longueur autorisée du text dans le noeud avant de le tronquer.
 * @returns length restante après troncature (car fonction récursive)
 */
const iterateOverDOMNodes = (element, authorizedLength) => {
    if (element.nodeType === document.TEXT_NODE) {
        const elementTextContent = element.textContent;
        if (elementTextContent.length <= authorizedLength) {
            authorizedLength -= elementTextContent.length;
        } else {
            let truncatedText = elementTextContent.substring(0, authorizedLength);
            if (truncatedText) {
                truncatedText += '...';
            }
            const truncatedTextWithDOMNodes = document.createTextNode(truncatedText);
            element.parentNode.replaceChild(truncatedTextWithDOMNodes, element);
            authorizedLength = 0;
        }
    } else {
        const DOMchildren = Array.from(element.childNodes);
        DOMchildren.forEach((DOMchild) => {
            authorizedLength = iterateOverDOMNodes(DOMchild, authorizedLength);
        });
    }
    return authorizedLength;
};

/**
 * Goal : Tronquer le contenu text d'un arbre de noeuds HTML.
 * @param stringifyDOMtree Noeud HTLM à tronquer, sous forme de string.
 * @param authorizedLength limite de longueur autorisée pour le text, avant de la tronquer, par défaut à 256 caractères.
 * @returns DOM tree tronquée, sous forme de string.
 */
export function truncateHTML(stringifyDOMtree, authorizedLength = 256) {
    const element = document.createElement('div');
    element.innerHTML = stringifyDOMtree;

    iterateOverDOMNodes(element, authorizedLength);
    Array.from(element.children).forEach((child) => {
        if (child.innerText.trim() === '') {
            child.parentNode.removeChild(child);
        }
    });
    return element.innerHTML;
}
